import React, { Component } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

// To handle requests
import GroupsAPI from '../utils/GroupsAPI';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';
import { namespace } from '../../../config.json';

class DeleteGroupButtonComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            modalErrorAlert: '',
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submit = this.submit.bind(this);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({ showModal: false, modalErrorAlert: '' });
    }

    // Fired when modal is submitted
    submit() {
        // Launching delete group action
        GroupsAPI.deleteGroup(this.props.groupname).then(() => {
            this.closeModal();
            // Calling specified callback if any
            if (this.props.callback) {
                this.props.callback();
            }
        }).catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            }
            if (message.status === 409) {
                if (message.response.body.error ===
                    'unable to delete default group') {
                    return this.setState({
                        modalErrorAlert: 'Unable to delete default group.',
                    });
                }
                return this.setState({
                    modalErrorAlert: `Cannot delete group. You must first
                                      remove all users from the group.`,
                });
            }
            return this.setState({
                modalErrorAlert: `Unable to process the request as the
                                  server returned an Internal Error.`,
            });
        });
    }

    render() {
        let errorAlert;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger">
                {this.state.modalErrorAlert}
            </Alert>;
        }

        return (
            <button
              className="btn btn-primary btn-xs delete-group-btn"
              style={brandingStyles.buttons.primary}
              onClick={this.openModal}
            >
                <i className="fa fa-times"></i>

                <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-trash"
                              style={brandingStyles.mainColor}
                            ></i>
                            <span>&nbsp;</span>
                            Delete group
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                        <p>Are you sure you want to delete group
                            <span>&nbsp;</span>
                            <strong>{this.props.groupname}</strong>
                            ?
                        </p>
                        <div className="alert alert-warning">
                            <strong>
                                <i className="fa fa-exclamation-triangle"
                                  style={{
                                      color: 'orange',
                                  }}></i>
                                &nbsp;
                                This cannot be undone.<br/><br/>
                                Please ensure that no users belong to this group
                                or the operation will fail.</strong>
                        </div>
                        {errorAlert}
                    </Modal.Body>
                    <Modal.Footer style={brandingStyles.backgrounds.panel}>
                        <button
                          className="btn btn-primary"
                          style={brandingStyles.buttons.primary}
                          onClick={this.submit}
                        >
                            Proceed
                        </button>
                        <button
                          className="btn btn-primary"
                          style={brandingStyles.buttons.primary}
                          onClick={this.closeModal}
                        >
                            Cancel
                        </button>
                    </Modal.Footer>
                </Modal>
            </button>

        );
    }

}

// Groupname is mandatory for delete operation to work
DeleteGroupButtonComponent.propTypes = {
    groupname: PropTypes.string.isRequired,
    callback: PropTypes.func,
};

export default DeleteGroupButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/DeleteGroupButton.js
 **/